module.exports = __webpack_public_path__ + "img/5.da897a7d.jpg";